import { render, staticRenderFns } from "./cardTopTables.vue?vue&type=template&id=15852116&scoped=true&"
import script from "./cardTopTables.vue?vue&type=script&lang=js&"
export * from "./cardTopTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15852116",
  null
  
)

export default component.exports